import { getSmallContainer } from '@platform-ui/icon';
const svgContent = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 1h10v2H3v8H1V1Zm5 5h7v6a1 1 0 0 1-1 1H6V6ZM4 4h11v8a3 3 0 0 1-3 3H4V4Z" fill="currentColor"/></svg>';
export const TuiIconTdsSmallPragmaticCopy = /*#__PURE__*/ getSmallContainer(svgContent);
